import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { ReportsStyled } from "./styled";
import { t } from "i18next";
import { CustomTable } from "../Dashboard/TrackHistory/TrackHistory";
import AuthStore from "../../../stores/auth/auth.store";
import axios from "axios";
import moment from "moment";
import { ColumnType } from "antd/lib/table";
import { cn } from "../../../utils";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import alef from "./Alef-Regular-normal";

interface Props extends RouteComponentProps<any> {
  authStore?: AuthStore;
}

function getTop5Mixes(mixes: MixtureBehaviorSmall[]): MixtureBehaviorSmall[] {
  return mixes
    .filter((mix) => mix.total_cube_week !== undefined) // Ensure valid values
    .sort((a, b) => b.total_cube_week - a.total_cube_week) // Descending order
    .slice(0, 5); // Get the first 5 items
}

async function createPdf(mixes: any[]) {
  if (!mixes || mixes.length === 0) {
    return;
  }
  console.log({ mixes });
  // const top_5_mixes = getTop5Mixes(mixes);

  const mixesDate = mixes[0].date;
  mixes = mixes.filter((mix) => mix.total_cube_month_company > 0);
  console.log({ mixes });

  const doc = new jsPDF();

  const backgroundBase64 =
    "data:image/png;base64,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"; // Replace with your Base64 image\

  // Get page dimensions

  // Add background image
  doc.addImage(backgroundBase64, "PNG", 3, 3, 67, 14);

  // const pageWidth = doc.internal.pageSize.getWidth();
  // const pageHeight = doc.internal.pageSize.getHeight();

  // // Add background image
  // doc.addImage(backgroundBase64, "PNG", 0, 0, pageWidth / 2, pageHeight / 2);

  let y = 60;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text(
    `Weekly Report ${moment(mixesDate)
      .subtract(1, "week")
      .format("DD/MM/YYYY")} - ${moment(mixesDate).format("DD/MM/YYYY")}`,
    105,
    y,
    { align: "center" }
  );

  y += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);

  const title = "Mix Designs Behavior Summary";
  const title_x = 105; // Center alignment X position
  const title_y = 20; // Y position for the text

  // Add the title text
  doc.text(" Mix Designs Behavior Summary", 105, y, { align: "center" });

  // Measure the width of the title text to calculate the underline
  const textWidth = doc.getTextWidth(title);

  // Draw the underline just below the text
  const lineY = y + 2; // Adjust this value to control the underline's position
  doc.line(title_x - textWidth / 2, lineY, title_x + textWidth / 2, lineY);

  y += 30;
  doc.setFontSize(14); // Default font size

  doc.text(
    "Here is the analysis of recommendations for correction and optimization",
    15, // Align text to the left by starting at 15
    y
  );
  y += 6;
  doc.text(
    "of the slump level according to mixtures, based on the behavior analysis ",
    15, // Align text to the left by starting at 15
    y
  );

  y += 6; // Space between lines
  doc.text(
    "of the mixtures.",
    15, // Align text to the left
    y
  );

  // Add smaller text
  y += 12;
  doc.setFontSize(8); // Smaller font size
  doc.text(
    "Model for calculating economic savings resulting from correction actions: ",
    15, // Align text to the left
    y
  );
  y += 3; // Space between lines
  doc.text(
    "the example is based on a cost of 0.5$ per slump level per cubic meter.",
    15, // Align text to the left
    y
  );

  y += 10;

  // Add a table with mixture data
  y += 20;
  const tableColumnHeaders = [
    "ID",
    "Mix Design Code",
    "Average Deviation",
    "Slump level correction",
    "Cubic Meters	",
    "Cost Savings Potential",
  ];
  const tableRows = mixes.map((mix) => [
    mix.id || "",
    mix.mixture_code || "",
    mix.slump_deviation_week || "",
    mix.slump_deviation_week / 25 || "",
    mix.total_cube_month_company || "",

    t("$") + (mix.slump_deviation_week / 25) * 0.5 + " " + " per cubic meter",
  ]);

  autoTable(doc, {
    startY: y,
    head: [tableColumnHeaders],
    body: tableRows,
    styles: {
      font: "ariel",
      fontStyle: "normal",
      cellPadding: 3,
      fontSize: 10,
    },
    headStyles: {
      fillColor: [100, 100, 100],
      textColor: [255, 255, 255],
    },
    bodyStyles: {
      fillColor: [240, 240, 240],
    },
  });

  // Save the PDF
  doc.save("Weekly_Report.pdf");
}
type MixtureBehavior = {
  createdAt: string;
  date: string;
  factory_id: number;
  group_id: number;
  id: number;
  mixture_code: string;
  mixture_name: string;
  number_of_deliveries_day: number;
  number_of_deliveries_month: number;
  number_of_deliveries_week: number;
  total_cube_month_company: number;
  slump_deviation_day: number;
  slump_deviation_month: number;
  slump_deviation_week: number;
  total_cube_day: number;
  total_cube_month: number;
  total_cube_week: number;
  action_status: string;
  updatedAt: string;
  status: string;
  report_status: string;
};
type MixtureBehaviorSmall = Pick<
  MixtureBehavior,
  | "date"
  | "id"
  | "mixture_code"
  | "mixture_name"
  | "report_status"
  | "slump_deviation_week"
  | "number_of_deliveries_week"
  | "action_status"
  | "total_cube_week"
  | "slump_deviation_week"
  | "total_cube_month_company"
>;

async function fetchAllReports(group_id: number | string) {
  const rsp = await axios.get(
    `${process.env.REACT_APP_API_URL}/mixtures_behavior/reports-grouped/${group_id}`
  );

  return rsp.data.data;
}

type Grouped = {
  month: string;
  date: Date;
  items: {
    week: string;
    date: Date;
    items: { date: Date; items: MixtureBehaviorSmall[] }[];
  }[];
}[];

type MonthItem = Grouped[number];
type WeekItem = MonthItem["items"][number];

@inject("authStore")
@observer
class ReportsClose extends React.PureComponent<Props, any> {
  @observable group_id = this.props.authStore!.getUserGroipID();
  @observable reports: Grouped = [];

  componentDidMount = async () => {
    try {
      fetchAllReports(this.group_id).then((data) => {
        console.log(data);
        this.reports = data;
      });
    } catch (error) {
      console.error(error);
    }
  };

  getSavingPotential(item: any, displayTime: string) {
    if (displayTime === "day") {
      if (item.slump_deviation_day < 0) {
        return 0;
      }
      return Math.round(
        (item.slump_deviation_day / 25) * item.total_cube_day * 0.5
      );
    }

    if (displayTime === "week") {
      if (item.slump_deviation_week < 0) {
        return 0;
      }
      return Math.round(
        (item.slump_deviation_week / 25) * item.total_cube_month_company * 0.5
      );
    }

    if (displayTime === "month") {
      if (item.slump_deviation_month < 0) {
        return 0;
      }
      return Math.round(
        (item.slump_deviation_month / 25) * item.total_cube_month * 0.5
      );
    }
  }

  columns: ColumnType<WeekItem>[] = [
    {
      title: t("Report Date"),
      dataIndex: "week",
      className: "text-start",
      width: 200,
    },
    {
      title: t("Report Creation Date"),
      render: (_, record) => {
        const firstItem = record.items[0].items[0];
        return moment(firstItem.date).format("DD/MM/YYYY");
      },
      className: "text-start",
      width: 200,
    },
    {
      title: t("Status"),
      width: 50,
      render: (_, record, recordIndex) => {
        const isClosed = record.items.some((item) =>
          item.items.every((item) => item.report_status === "closed")
        );

        return (
          <div
            className={cn(
              "text-center text-white rounded-lg font-semibold text-sm w-20 h-7 flex items-center justify-center",
              isClosed ? "bg-[#31C48D]" : "bg-[#F98080]"
            )}
          >
            {isClosed ? t("Closed") : t("Open")}
          </div>
        );
      },
    },
    {
      title: t(""),
      dataIndex: "createdAt",
      render: (_, record) => {
        const isClosed = record.items.some((item) =>
          item.items.every((item) => item.report_status === "closed")
        );

        const lastItems = record.items[0].items;
        const openUrl = `/reports/open?date=${moment(record.date).format(
          "DD/MM/YYYY"
        )}`;
        return (
          <div className="flex items-center gap-5 px-2.5">
            {!isClosed && (
              <a href={openUrl}>
                <img
                  src="/images/actions/pencil.svg"
                  alt="pencil"
                  className="w-5 h-5"
                />
              </a>
            )}
            {isClosed && (
              <a href={openUrl}>
                <img
                  src="/images/actions/eye.svg"
                  alt="eye"
                  className="w-5 h-5"
                />
              </a>
            )}
            {isClosed && (
              <img
                src="/images/actions/open-link.svg"
                alt="open link"
                className="w-5 h-5"
              />
            )}
            {isClosed && (
              <img
                onClick={() => createPdf(lastItems)}
                src="/images/actions/download.svg"
                alt="download"
                className="w-5 h-5 cursor-pointer"
              />
            )}
          </div>
        );
      },
    },
  ];

  render() {
    return (
      <ReportsStyled>
        <div className="content-page">
          <div className="font-semibold text-3xl mb-10">Closed Reports</div>

          <div className="flex flex-col gap-4">
            {this.reports.map((month) => (
              <div className="flex flex-col gap-2" key={month.month}>
                <div className="title">{month.month}</div>
                <div className="box">
                  <div className="items">
                    <CustomTable
                      rowKey={(record) => record.week}
                      columns={this.columns}
                      data={month.items}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ReportsStyled>
    );
  }
}
export default withRouter(ReportsClose);
